import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ThemeToggle from "../components/ThemeToggle";
import LanguageToggle from "../components/LanguageToggle";
import styles from "./Portal.module.css";

type ProjectEntry = {
  key: string;
  path: string;
  accent: string;
};

const PROJECTS: ProjectEntry[] = [
  { key: "kiraArts", path: "/docs/kira-arts", accent: "var(--rule-custom)" },
];

export default function Portal() {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <header className={styles.nav}>
        <span className={styles.brand}>
          word<span>devs</span>
        </span>
        <div className={styles.navLinks}>
          <ThemeToggle />
          <LanguageToggle />
        </div>
      </header>

      <section className={styles.hero}>
        <p className={styles.eyebrow}>{t("portal.eyebrow")}</p>
        <h1 className={styles.title}>{t("portal.title")}</h1>
        <p className={styles.subtitle}>{t("portal.subtitle")}</p>
      </section>

      <section className={styles.grid}>
        {PROJECTS.map((project) => (
          <Link
            key={project.key}
            to={project.path}
            className={styles.card}
            style={{ ["--accent" as string]: project.accent }}
          >
            <span className={styles.cardTitle}>
              {t(`portal.projects.${project.key}.title`)}
            </span>
            <span className={styles.cardDescription}>
              {t(`portal.projects.${project.key}.description`)}
            </span>
            <span className={styles.cardCta}>
              {t(`portal.projects.${project.key}.cta`)}
              <ArrowIcon />
            </span>
          </Link>
        ))}
      </section>

      <p className={styles.footer}>{t("portal.footer")}</p>
    </div>
  );
}

function ArrowIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" width="14" height="14" aria-hidden="true">
      <path
        d="M6 3.5 10.5 8 6 12.5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
